/**
 * (c) 2021, Micro:bit Educational Foundation and contributors
 *
 * SPDX-License-Identifier: MIT
 */
import { useCallback } from "react";
import FileDropTarget from "./FileDropTarget";
import { useProject } from "../hooks/project-hooks";

interface ProjectDropTargetProps {
  children: React.ReactElement;
  isEnabled: boolean;
}

const ProjectDropTarget = ({ children, isEnabled }: ProjectDropTargetProps) => {
  const { loadFile } = useProject();
  const handleDrop = useCallback(
    (files: File[]) => {
      if (files.length === 1) {
        void loadFile(files[0], "drop-load", "replaceProject");
      }
    },
    [loadFile]
  );
  return (
    <FileDropTarget isEnabled={isEnabled} onFileDrop={handleDrop}>
      {children}
    </FileDropTarget>
  );
};

export default ProjectDropTarget;
